import { render, staticRenderFns } from "./SelectBoxes.vue?vue&type=template&id=418c0aac&scoped=true"
import script from "./SelectBoxes.vue?vue&type=script&lang=js"
export * from "./SelectBoxes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418c0aac",
  null
  
)

export default component.exports